<div class="mx-auto h-full flex flex-column align-items-center justify-content-center text-center	">
    <img src="./assets/icons/check-square.svg" alt="Check square" class="mb-4 md:mb-6" />
    <h2 class="text-3xl md:text-5xl font-semibold mb-4 mt-2" data-clarity-unmask="true">Twoje zamówienie zostało opłacone</h2>
    <p class="text-lg md:text-xl mb-6">Możesz teraz korzystać z zamówionych abonamentów. </p>
    <p-button label="Przejdź do zakładki Abonamanty" icon="pi pi-arrow-right" iconPos="right" (onClick)="goToSubscriptionList()" data-clarity-unmask="true" ></p-button>
</div>
